import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { memo } from "react";
import { useFormik } from "formik";

// Components
import { TextField, Button } from "../../../components/UI";
import { Paragraph, Span } from "../../../components/typography";

// Builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";

// Form Models
import { LoginFormModel } from "../../../models/app/forms";

// Actions
import { login } from "../../../redux/actions/app.actions";

// Services
import { loginValidate } from "../../../services/validations/login.validations";

// Styles
import { LoginFormStyles } from "./loginForm.styles";

const LoginForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogin = async values => {
    dispatch(login(values));
  };

  const formik = useFormik({
    initialValues: new LoginFormModel(),
    onSubmit: handleLogin,
    validate: loginValidate
  });

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } =
    formik;

  return (
    <LoginFormStyles>
      <form onSubmit={handleSubmit} className="form">
        <div>
          <TextField
            name="email"
            type="email"
            placeholder="Email address"
            value={values.email}
            touched={touched.email}
            error={errors.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        <div>
          <TextField
            name="password"
            type="password"
            placeholder="Password"
            value={values.password}
            touched={touched.password}
            error={errors.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <div className="forgotPassword">
            <Span onClick={() => history.push("/forgot-password")} className="link">
              Forgot Password
            </Span>
          </div>
        </div>
        <Button
          type="submit"
          buttonDesignType={buttonDesignType.PRIMARY}
          style={{ width: "100%" }}
        >
          Log In
        </Button>
        <Paragraph className="signUp">
          Don't have an account?{" "}
          <Span className="link" onClick={() => history.push("/register")}>
            Sign Up
          </Span>
        </Paragraph>
      </form>
    </LoginFormStyles>
  );
};

export default memo(LoginForm);
